var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registerDialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.dialogVisible,
            "show-close": false,
            "custom-class": "customDialog",
            width: "557px",
            top: "8vh",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "mainContent" }, [
            _c("div", { staticClass: "titileBox" }, [
              _c("div", { staticClass: "userInfo" }, [_vm._v("用户信息注册")]),
              _c("div", { staticClass: "text" }, [
                _vm._v("通过审核后即可登录进行模拟考试练习"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "dialogMain" },
              [
                _c(
                  "el-form",
                  {
                    ref: "registerForm",
                    attrs: {
                      model: _vm.registerForm,
                      size: "mini",
                      rules: _vm.registerRules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c("div", { staticClass: "form-child-box" }, [
                      _c(
                        "div",
                        { staticClass: "form-left" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "姓名", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "mini",
                                  readonly: "",
                                  placeholder: "请输入姓名",
                                  onfocus: "this.removeAttribute('readonly');",
                                },
                                model: {
                                  value: _vm.registerForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "registerForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "身份证号", prop: "idCard" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "mini",
                                  readonly: "",
                                  placeholder: "请输入身份证号",
                                  onfocus: "this.removeAttribute('readonly');",
                                },
                                model: {
                                  value: _vm.registerForm.idCard,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "idCard",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "registerForm.idCard",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "就读院校", prop: "orgData" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "请选择就读院校",
                              clearable: "",
                              "value-key": "deptId",
                            },
                            model: {
                              value: _vm.registerForm.orgData,
                              callback: function ($$v) {
                                _vm.$set(_vm.registerForm, "orgData", $$v)
                              },
                              expression: "registerForm.orgData",
                            },
                          },
                          _vm._l(_vm.orgDataList, function (item) {
                            return _c("el-option", {
                              key: item.deptId,
                              attrs: { label: item.name, value: item },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "专业", prop: "major" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            readonly: "",
                            placeholder: "请输入专业",
                            onfocus: "this.removeAttribute('readonly');",
                          },
                          model: {
                            value: _vm.registerForm.major,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.registerForm,
                                "major",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "registerForm.major",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "validBox" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号码", prop: "mobile" } },
                          [
                            _c("el-input", {
                              style: { width: "375px" },
                              attrs: {
                                size: "mini",
                                placeholder: "请输入手机号",
                                readonly: "",
                                onfocus: "this.removeAttribute('readonly');",
                              },
                              model: {
                                value: _vm.registerForm.mobile,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.registerForm,
                                    "mobile",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "registerForm.mobile",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "isVerifyCodeBox" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "0px" },
                                attrs: {
                                  label: "",
                                  "label-width": "0px",
                                  prop: "verifyCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "170px",
                                    "margin-left": "20px",
                                  },
                                  attrs: {
                                    readonly: "",
                                    onfocus:
                                      "this.removeAttribute('readonly');",
                                    placeholder: "验证码",
                                  },
                                  model: {
                                    value: _vm.registerForm.verifyCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "verifyCode",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "registerForm.verifyCode",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "timeBox" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        class: { codeGeting: _vm.isGeting },
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          disabled: _vm.disable,
                                        },
                                        on: { click: _vm.getVerifyCode },
                                      },
                                      [_vm._v(_vm._s(_vm.getCode))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "密码", prop: "password" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            "show-password": "",
                            readonly: "",
                            placeholder: "请输入密码",
                            onfocus: "this.removeAttribute('readonly');",
                          },
                          model: {
                            value: _vm.registerForm.password,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.registerForm,
                                "password",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "registerForm.password",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "重复密码", prop: "repeatPwd" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            "show-password": "",
                            readonly: "",
                            placeholder: "请重复输入密码",
                            onfocus: "this.removeAttribute('readonly');",
                          },
                          model: {
                            value: _vm.registerForm.repeatPwd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.registerForm,
                                "repeatPwd",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "registerForm.repeatPwd",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function () {
                          _vm.cancel()
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        loading: _vm.btnLoading,
                      },
                      on: { click: _vm.confirmBtn },
                    },
                    [_vm._v("申 请")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }